import Vue from 'vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import 'babel-polyfill'
import BaiduMap from 'vue-baidu-map';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.css'
import './assets/font/iconfont.css'
import './assets/fonts_new/iconfont.css'
import animated from 'animate.css'
import App from './Vue.vue'
import router from './router/index'
import promise from 'es6-promise'
promise.polyfill()
import 'default-passive-events' //解决在使用element-ui时出现警告[Violation] 
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(animated)
Vue.use(BaiduMap, {
    ak: process.env.VUE_APP_BAIDU_MAP_AK || '40c2114270cee7664149034c29b7f681'
});
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')


var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?9392348243506517fca463f97c7aa3c8";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, form, next) => {
    if(_hmt){
        if(to.path){
            _hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    next();
});
